import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { Storage } from 'aws-amplify';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import backofficeService from '../../../../services/backofficeService';
import { DownloadOutlined } from '@ant-design/icons';

export default function BotonDescargaMasiva({ selectedRowKeys, tipo }) {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('sessionToken');

  const descargarContratos = async (array) => {
    setLoading(true);
    const zip = new JSZip();
    const promises = [];
    array.forEach((obj) => {
      const pathContratos = Object.keys(obj.pathContratos);
      pathContratos.forEach((path) => {
        const arrayContratos = obj.pathContratos[path];
        const fileKey = arrayContratos;
        promises.push(
          Storage.get(fileKey, { download: true }).then((fileData) => {
            let blob = fileData;
            if (!(fileData instanceof Blob)) {
              try {
                blob = new Blob([fileData.Body], { type: 'application/pdf' });
              } catch (error) {
                console.error(
                  'Error al convertir los datos en un Blob:',
                  error
                );
                return;
              }
            }
            const folderTrabajador = zip.folder(
              `${obj.idOferta}-${obj.nombreEmpresa}-${obj.nombre}-${obj.dni}`
            );
            folderTrabajador.file(path + '.pdf', blob);
          })
        );
      });
    });
    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        saveAs(content, 'Contratos.zip');
      });
    });
    setLoading(false);
  };

  const descargarDocumentos = async (array) => {
    setLoading(true);
    const zip = new JSZip();
    const promises = [];
    for (const obj of array) {
      const response = await backofficeService.consultarTrabajador(
        token,
        obj.empresaId,
        obj.correo,
        25,
        ''
      );
      const data = response[0].data.registro;
      if (data) {
        const pathDocumentos = data[0].documentos;
        const folderName = `${data[0].nombre} ${data[0].primerApellido} ${data[0].segundoApellido}-${data[0].dni}`;
        pathDocumentos.forEach((element) => {
          const fileUrl = element.url;
          promises.push(
            fetch(fileUrl)
              .then((response) => response.blob())
              .then((blob) => {
                const extension = element.tipo + '.pdf';
                const blobNamed = new Blob([blob], { type: 'application/pdf' });
                const folderTrabajador = zip.folder(folderName);
                folderTrabajador.file(extension, blobNamed);
              })
          );
        });
      }
    }
    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        saveAs(content, 'Documentos.zip');
      });
    });
    setLoading(false);
  };

  return (
    <Space>
      {tipo === 'Contratos' && (
        <Button
          type="primary"
          disabled={selectedRowKeys.length === 0}
          loading={loading}
          style={{ marginRight: '10px' }}
          onClick={() => descargarContratos(selectedRowKeys)}
        >
          Descargar Contratos
          <DownloadOutlined />
        </Button>
      )}
      {tipo === 'Documentos' && (
        <Button
          type="primary"
          disabled={selectedRowKeys.length === 0}
          loading={loading}
          onClick={() => descargarDocumentos(selectedRowKeys)}
        >
          Descargar Documentos
          <DownloadOutlined />
        </Button>
      )}
    </Space>
  );
}
